var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "execution" },
    [
      _c(
        "basic-container",
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 4 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { placeholder: "请选择数据源" },
                        on: { change: _vm.search },
                        model: {
                          value: _vm.q.dsName,
                          callback: function ($$v) {
                            _vm.$set(_vm.q, "dsName", $$v)
                          },
                          expression: "q.dsName",
                        },
                      },
                      _vm._l(_vm.dataSourceList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.name },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 4 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "表名称" },
                      model: {
                        value: _vm.q.tableName,
                        callback: function ($$v) {
                          _vm.$set(_vm.q, "tableName", $$v)
                        },
                        expression: "q.tableName",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", icon: "el-icon-search" },
                        on: { click: _vm.search },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", icon: "el-icon-document" },
                        on: { click: _vm.downDocument },
                      },
                      [_vm._v("导出文档")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", icon: "el-icon-download" },
                        on: { click: _vm.openBatch },
                      },
                      [_vm._v("批量生成")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c("avue-crud", {
            ref: "crud",
            attrs: {
              page: _vm.page,
              data: _vm.tableData,
              "table-loading": _vm.tableLoading,
              option: _vm.tableOption,
            },
            on: {
              "update:page": function ($event) {
                _vm.page = $event
              },
              "on-load": _vm.getList,
              "size-change": _vm.sizeChange,
              "current-change": _vm.currentChange,
              "refresh-change": _vm.refreshChange,
            },
            scopedSlots: _vm._u([
              {
                key: "menuBtn",
                fn: function (scope) {
                  return [
                    _c(
                      "el-dropdown-item",
                      {
                        attrs: { divided: "", icon: "el-icon-view" },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.handleTable(scope.row, scope.index)
                          },
                        },
                      },
                      [_vm._v("字段\n        ")]
                    ),
                    _c(
                      "el-dropdown-item",
                      {
                        attrs: { divided: "", icon: "el-icon-check" },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.handleDown(scope.row, scope.index)
                          },
                        },
                      },
                      [_vm._v("下载\n        ")]
                    ),
                    _c(
                      "el-dropdown-item",
                      {
                        attrs: { divided: "", icon: "el-icon-edit" },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.handleDesign(scope.row, scope.index)
                          },
                        },
                      },
                      [_vm._v("设计\n        ")]
                    ),
                    _c(
                      "el-dropdown-item",
                      {
                        attrs: { divided: "", icon: "el-icon-share" },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.copyLink(scope.row, scope.index)
                          },
                        },
                      },
                      [_vm._v("运行\n        ")]
                    ),
                    _c(
                      "el-dropdown-item",
                      {
                        attrs: { divided: "", icon: "el-icon-mouse" },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.lowCode(scope.row, scope.index)
                          },
                        },
                      },
                      [_vm._v("低代码\n        ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.box,
                title: "生成配置",
                width: "50%",
                "lock-scroll": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.box = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "pull-auto" },
                [
                  _c(
                    "avue-form",
                    {
                      ref: "formData",
                      attrs: { option: _vm.formOption },
                      model: {
                        value: _vm.formData,
                        callback: function ($$v) {
                          _vm.formData = $$v
                        },
                        expression: "formData",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "menuForm" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                icon: "el-icon-view",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleView()
                                },
                              },
                            },
                            [_vm._v("预览\n            ")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "info",
                                icon: "el-icon-check",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.gen()
                                },
                              },
                            },
                            [_vm._v("下载\n            ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.boxBatch,
                title: "批量生成",
                width: "50%",
                "lock-scroll": "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.boxBatch = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "pull-auto" },
                [
                  _c("avue-form", {
                    ref: "formBatchData",
                    attrs: { option: _vm.formBatchOption },
                    on: { submit: _vm.batchGen },
                    model: {
                      value: _vm.formBatchData,
                      callback: function ($$v) {
                        _vm.formBatchData = $$v
                      },
                      expression: "formBatchData",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.preview.title,
            visible: _vm.preview.open,
            width: "80%",
            top: "5vh",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.preview, "open", $event)
            },
          },
        },
        [
          _vm.preview.open
            ? _c("Preview", { attrs: { "query-data": _vm.formData } })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.table.title,
            visible: _vm.table.open,
            width: "80%",
            top: "5vh",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.table, "open", $event)
            },
          },
        },
        [
          _vm.table.open
            ? _c("Table", { attrs: { "query-data": _vm.formData } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }